import axios from 'axios';
import { notification } from 'antd';

export const initializeTokenGeneration = (initialize) => (dispatch) => {
  return dispatch({
    type: 'INITIALIZE_TOKEN_GENERATION_FOR_INDUSTRY',
    payload: { loading: initialize }
  });
}

export const donateWithPaypalForCompany = ({ company_id, users_id, amount, first_name, last_name, email, phone_number }) => (dispatch) => {
  dispatch({
    type: 'DONATE_WITH_PAYPAL_FOR_COMPANY_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/donate_with_paypal_for_company',
    method: 'POST',
    data: {
      company_id,
      users_id,
      amount,
      first_name,
      last_name,
      email,
      phone_number
    }
  }).then(({ data }) => {
    const { flag } = data;
    if (!flag) {
      notification.error({
        message: 'DONATE WITH PAYPAL',
        description: 'Could not process paypal payment'
      });
      dispatch({
        type: 'DONATE_WITH_PAYPAL_FOR_COMPANY_FAILED',
        payload: { loading: false }
      });
      return Promise.reject();
    } else {
      notification.success({
        message: 'DONATION',
        description: 'donation payment saved successfully !'
      });
      return dispatch({
        type: 'DONATE_WITH_PAYPAL_FOR_COMPANY_SUCCESS',
        payload: {
          loading: false
        }
      });
    }
  }).catch((error) => {
    notification.error({
      message: 'DONATE WITH PAYPAL',
      description: error.message
    });

    return dispatch({
      type: 'DONATE_WITH_PAYPAL_FOR_COMPANY_FAILED',
      payload: { loading: false }
    });
  })
}

export const payWithCard = ({ token, paymentType, company_id, amount, first_name, phone_number, last_name, email }) => (dispatch) => {
  dispatch({
    type: 'PAY_WITH_CARD_FOR_INDUSTRY_DONATION_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/payment_for_company_by_stripe',
    method: 'POST',
    data: {
      token,
      company_id,
      amount,
      first_name,
      last_name,
      phone_number,
      email,
      package: paymentType
    }
  }).then(({ data: response }) => {
    const { flag, message } = response;
    if (!flag) {
      notification.error({
        message: 'PAY WITH CARD',
        description: message.error
      });
  
      dispatch({
        type: 'PAY_WITH_CARD_FOR_INDUSTRY_DONATION_FAILED',
        payload: { loading: false }
      });
      return Promise.reject();
    } else {
      notification.success({
        message: 'PAY WITH CARD',
        description: 'Charged successfully !'
      });
      return dispatch({
        type: 'PAY_WITH_CARD_FOR_INDUSTRY_DONATION_SUCCESS',
        payload: {
          loading: false
        }
      });
    }
  }).catch((error) => {
    notification.error({
      message: 'PAY WITH CARD',
      description: error.message
    });

    return dispatch({
      type: 'PAY_WITH_CARD_FOR_INDUSTRY_DONATION_FAILED',
      payload: { loading: false }
    });
  })
}

export const payByBill = ({ company_id, email, first_name, last_name, phone_number, method, billFile }) => (dispatch) => {
  dispatch({
    type: 'PAY_UTILITY_BILL_PAYMENT_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/upload_bill',
    method: 'POST',
    data: {
      company_id,
      email,
      first_name, 
      last_name, 
      phone_number, 
      method: JSON.stringify(method), 
      billFile: JSON.stringify(billFile)
    }
  }).then(({ data }) => {
    const { flag, message } = data;
    if (!flag) {
      notification.error({
        message: 'UPLOAD UTILITY BILL',
        description: 'Could not process utility bill payment'
      });
      dispatch({
        type: 'PAY_UTILITY_BILL_PAYMENT_FAILED',
        payload: { loading: false }
      });
      return Promise.reject();
    } else {
      notification.success({
        message: 'UPLOAD UTILITY BILL',
        description: message.message
      });
      return dispatch({
        type: 'PAY_UTILITY_BILL_PAYMENT_SUCCESS',
        payload: {
          loading: false
        }
      });
    }
  }).catch((error) => {
    notification.error({
      message: 'UPLOAD UTILITY BILL',
      description: error.message
    });

    return dispatch({
      type: 'PAY_UTILITY_BILL_PAYMENT_FAILED',
      payload: { loading: false }
    });
  })
}

export const getDonationTypes = () => (dispatch) => {
  dispatch({
    type: 'GET_DONATION_TYPES_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/get_donate_your_bills_section',
    method: 'GET'
  }).then(({ data: response }) => {
    const { data } = response;
    return dispatch({
      type: 'GET_DONATION_TYPES_SUCCESS',
      payload: {
        donationTypes: data,
        loading: false
      }
    });
  }).catch((error) => {
    notification.error({
      message: 'GET DONATION TYPES',
      description: error.message
    });

    return dispatch({
      type: 'GET_DONATION_TYPES_FAILED',
      payload: { loading: false }
    });
  })
}

export const getCommunity = (charity_id, from) => (dispatch) => {
  dispatch({
    type: 'GET_COMMUNITY_BY_ID_FOR_DONATE_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/get_charity_by_id',
    method: 'POST',
    data: {
      charity_id,
      from
    }
  }).then(({ data: response }) => {
    const { data } = response;
    const { charity } = data || {};
    return dispatch({
      type: 'GET_COMMUNITY_BY_ID_FOR_DONATE_SUCCESS',
      payload: {
        community: charity,
        loading: false
      }
    });
  }).catch((error) => {
    notification.error({
      message: 'GET COMMUNITY BY ID',
      description: error.message
    });

    return dispatch({
      type: 'GET_COMMUNITY_BY_ID_FOR_DONATE_FAILED',
      payload: { loading: false }
    });
  })
}

export const getFeaturedIndustries = (industry) => (dispatch, getState) => {
  dispatch({
    type: 'GET_FEATURED_COMMUNITIES_FOR_DONATE_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/featured_industry',
    method: 'POST',
    params: {
      industry
    }
  }).then(({ data: response }) => {
    const { data } = response;
    const { charity } = data;
    return dispatch({
      type: 'GET_FEATURED_COMMUNITIES_FOR_DONATE_SUCCESS',
      payload: {
        loading: false,
        featuredCommunities: charity
      }
    });
  }).catch((error) => {
    notification.error({
      message: 'GET FEATURED COMMUNITY',
      description: error.message
    });

    return dispatch({
      type: 'GET_FEATURED_COMMUNITIES_FOR_DONATE_FAILED',
      payload: { loading: false }
    });
  })
}

export const likeCompanyType = (campaign_id, status, type, userOrBrowserInfo) => (dispatch) => {
  dispatch({
    type: 'LIKE_COMPANY_COMMUNITY_FOR_DONATE_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/like',
    method: 'POST',
    data: {
      from: userOrBrowserInfo.toString(),
      to: campaign_id.toString(),
      status,
      type: 'industry'
    }
  }).then(() => {
    return dispatch({
      type: 'LIKE_COMPANY_COMMUNITY_FOR_DONATE_SUCCESS',
      payload: {
        loading: false
      }
    });
  }).catch((error) => {
    notification.error({
      message: 'LIKE COMPANY TYPE',
      description: error.message
    });

    return dispatch({
      type: 'LIKE_COMPANY_COMMUNITY_FOR_DONATE_FAILED',
      payload: { loading: false }
    });
  })
}

export const shareCompany = (from, to, shared_on) => (dispatch, getState) => {
  dispatch({
    type: 'SHARE_COMMUNITY_FOR_DONATE_REQUEST',
    payload: { loading: true }
  });
  return axios({
    url: '/api/share',
    method: 'POST',
    params: {
      from: from.toString(),
      to: to.toString(),
      type: 'industry',
      shared_on
    }
  }).then(() => {
    return dispatch({
      type: 'SHARE_COMMUNITY_FOR_DONATE_SUCCESS',
      payload: {
        loading: false
      }
    });
  }).catch((error) => {
    notification.error({
      message: 'SHARE CHARITY',
      description: error.message
    });

    return dispatch({
      type: 'SHARE_COMMUNITY_FOR_DONATE_FAILED',
      payload: { loading: false }
    });
  })
}